/* Drop · expediente (sections/lb-drop.liquid)
   1) Contagem: antes do início mostra "antes", durante mostra "durante", depois esconde a compra.
   2) Combos: a cliente escolhe cada opção do produto do combo (Simple Bundles cria uma variante pra cada
      combinação) e o botão adiciona a variante certa à sacola. O brinde fica por conta do app de brinde. */
(function () {
  function dois(n) { return (n < 10 ? '0' : '') + n; }

  function contagem(raiz) {
    var ini = Date.parse(raiz.getAttribute('data-inicio'));
    var horas = parseFloat(raiz.getAttribute('data-horas')) || 24;
    if (isNaN(ini)) { raiz.setAttribute('data-lbd-estado', 'durante'); return; }
    var fim = ini + horas * 3600000;
    function tick() {
      var agora = Date.now();
      var estado = agora < ini ? 'antes' : (agora < fim ? 'durante' : 'depois');
      raiz.setAttribute('data-lbd-estado', estado);
      var resto = Math.max(0, Math.floor(((estado === 'antes' ? ini : fim) - agora) / 1000));
      var txt = dois(Math.floor(resto / 3600)) + ':' + dois(Math.floor((resto % 3600) / 60)) + ':' + dois(resto % 60);
      raiz.querySelectorAll('[data-lbd-relogio]').forEach(function (e) { e.textContent = txt; });
      if (estado !== 'depois') setTimeout(tick, 1000);
    }
    tick();
  }

  function combo(el) {
    var dados = el.querySelector('[data-lbd-variantes]');
    if (!dados) return;
    var variantes = JSON.parse(dados.textContent || '[]');
    var botao = el.querySelector('[data-lbd-add]');
    var msg = el.querySelector('[data-lbd-msg]');
    var escolha = [];
    var grupos = el.querySelectorAll('[data-lbd-opcao]');

    // valores que não existem em nenhuma variante disponível ficam desabilitados
    grupos.forEach(function (g) {
      var i = Number(g.getAttribute('data-lbd-opcao'));
      g.querySelectorAll('[data-valor]').forEach(function (b) {
        var ok = variantes.some(function (v) { return v.available && v.options[i] === b.getAttribute('data-valor'); });
        if (!ok) b.disabled = true;
      });
    });
    // opção com um valor só já vem escolhida
    grupos.forEach(function (g) {
      var i = Number(g.getAttribute('data-lbd-opcao'));
      var livres = g.querySelectorAll('[data-valor]:not([disabled])');
      if (livres.length === 1) { escolha[i] = livres[0].getAttribute('data-valor'); livres[0].setAttribute('aria-pressed', 'true'); marcar(g, escolha[i]); }
    });

    function marcar(g, valor) { var r = g.querySelector('[data-lbd-escolhido]'); if (r) r.textContent = valor || ''; }
    function achar() {
      if (!grupos.length) return variantes[0] || null;
      if (escolha.length < grupos.length) return null;
      for (var k = 0; k < grupos.length; k++) if (!escolha[k]) return null;
      return variantes.find(function (v) { return v.options.every(function (o, k) { return o === escolha[k]; }); }) || null;
    }

    el.addEventListener('click', function (e) {
      var b = e.target.closest('[data-valor]');
      if (b && !b.disabled) {
        var g = b.closest('[data-lbd-opcao]');
        var i = Number(g.getAttribute('data-lbd-opcao'));
        g.querySelectorAll('[data-valor]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
        escolha[i] = b.getAttribute('data-valor');
        marcar(g, escolha[i]);
        var v = achar();
        msg.textContent = (v && !v.available) ? el.getAttribute('data-txt-esgotado') : '';
        return;
      }
      if (e.target.closest('[data-lbd-add]')) {
        e.preventDefault();
        for (var k = 0; k < grupos.length; k++) {
          if (!escolha[k]) { msg.textContent = el.getAttribute('data-txt-falta') + ' ' + grupos[k].getAttribute('data-nome'); return; }
        }
        var v = achar();
        if (!v || !v.available) { msg.textContent = el.getAttribute('data-txt-esgotado'); return; }
        botao.disabled = true; msg.textContent = '';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            botao.disabled = false;
            if (!res.ok) { msg.textContent = res.j.description || res.j.message || el.getAttribute('data-txt-erro'); return; }
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            if (el.getAttribute('data-depois') === 'sacola') { window.location.href = el.getAttribute('data-url-sacola'); }
            else { msg.innerHTML = el.getAttribute('data-txt-ok') + ' <a href="' + el.getAttribute('data-url-sacola') + '">' + el.getAttribute('data-txt-ver') + '</a>'; }
          })
          .catch(function () { botao.disabled = false; msg.textContent = el.getAttribute('data-txt-erro'); });
      }
    });
  }

  function tudo() {
    document.querySelectorAll('[data-lbd]').forEach(contagem);
    document.querySelectorAll('[data-lbd-combo]').forEach(function (el) { if (!el.__lbd) { el.__lbd = true; combo(el); } });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tudo); else tudo();
  document.addEventListener('shopify:section:load', tudo);
})();
